export default __webpack_public_path__ + "static/media/undraw_buffer_dsav.2d013082.svg";